import React from 'react';
import './SocialLinks.css'

type Props = {
  lightBackground: boolean
}

export const SocialLinks = (props: Props) => {
  return (
      <div className={'SocialLinks'}>

        <SocialLink url={'https://www.instagram.com/on.kensu'}
                    altText={'Kensu on Instagram'}
                    image={props.lightBackground ?
                        require('../images/icons/instagram_black.png') :
                        require('../images/icons/instagram_white.png')}
        />

        <SocialLink url={'https://www.youtube.com/channel/UCUaAA4l2YKVLU2C0svBPCzw'}
                    altText={'Kensu on YouTube'}
                    image={props.lightBackground ?
                        require('../images/icons/youtube_black.png') :
                        require('../images/icons/youtube_white.png')}
        />

        <SocialLink url={'https://x.com/on_kensu'}
                    altText={'Kenko on X'}
                    image={props.lightBackground ?
                        require('../images/icons/x_black.png') :
                        require('../images/icons/x_white.png')}
        />

        <SocialLink url={'https://www.tiktok.com/@onkensu'}
                    altText={'Kensu on TikTok'}
                    image={props.lightBackground ?
                        require('../images/icons/tiktok_black.png') :
                        require('../images/icons/tiktok_white.png')}
        />
      </div>
  );
};

type SocialLinkProps = {
  url: string,
  altText: string,
  image: string,
}

const SocialLink = (props: SocialLinkProps) => {
  return <a href={props.url} target={'_blank'}>
    <img alt={props.altText}
         className={'SocialLink DarkModeInvert'}
         src={props.image}/>
  </a>
}